import { Pipe, PipeTransform } from '@angular/core';
import { KeyFigureElement } from '@widgets';

@Pipe({
    name: 'sbGroupAccounts',
    standalone: true
})
export class SbGroupAccountsPipe implements PipeTransform {
    transform(elements: Array<KeyFigureElement>) {
        const totalMarketValue = elements.reduce(
            (acc, element) => {
                const marketValue = element['value'].rawValue.marketValue;
                acc.absolute += Math.abs(marketValue);
                acc.real += marketValue;
                return acc;
            },
            { absolute: 0, real: 0 }
        );
        const relativeDailyPerformance = elements.reduce((acc, element) => {
            const marketValue = element['value'].rawValue.marketValue;
            const accountAttribution = Math.abs(marketValue) / totalMarketValue.absolute;
            const weightedRelativeDailyPerformance =
                element['value'].rawValue.relativeDailyPerformance * accountAttribution;
            return acc + weightedRelativeDailyPerformance;
        }, 0);

        return {
            totalMarketValue,
            relativeDailyPerformance,
            data: [...elements],
            baseCurrency: elements[0]['value'].rawValue.currency
        };
    }
}
